/**
 * NK - フローティングLINEボタン
 * スクロール時に表示/非表示を制御
 */

(function() {
  'use strict';

  const SCROLL_THRESHOLD = 300; // スクロール量の閾値（px）
  const BUTTON_ID = 'nk-floating-line-button';
  const VISIBLE_CLASS = 'nk-floating-line-button--visible';

  function initFloatingLineButton() {
    const button = document.getElementById(BUTTON_ID);
    if (!button) {
      return;
    }

    let ticking = false;

    function updateButtonVisibility() {
      const scrollY = window.pageYOffset || document.documentElement.scrollTop;
      
      if (scrollY > SCROLL_THRESHOLD) {
        button.classList.add(VISIBLE_CLASS);
      } else {
        button.classList.remove(VISIBLE_CLASS);
      }
      
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(updateButtonVisibility);
        ticking = true;
      }
    }

    // スクロールイベントリスナーを追加
    window.addEventListener('scroll', onScroll, { passive: true });
    
    // 初期状態をチェック
    updateButtonVisibility();
  }

  // DOMContentLoaded時に初期化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFloatingLineButton);
  } else {
    initFloatingLineButton();
  }
})();

